<template>
  <div class="chat-container" v-if="info">
    <div class="chat-header" v-if="userId > 0">
        <img v-if="info.image" :src="info.image" alt="user image" height="100%">
        <svg v-else height="100%" xmlns="http://www.w3.org/2000/svg" fill="#000000" enable-background="new 0 0 24 24" viewBox="0 0 24 24"><g><rect fill="none" height="24" width="24"></rect></g><g><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 4c1.93 0 3.5 1.57 3.5 3.5S13.93 13 12 13s-3.5-1.57-3.5-3.5S10.07 6 12 6zm0 14c-2.03 0-4.43-.82-6.14-2.88C7.55 15.8 9.68 15 12 15s4.45.8 6.14 2.12C16.43 19.18 14.03 20 12 20z"></path></g></svg>
        <b v-if="info.name || info.family">
          {{ info.name }} {{ info.family }}
        </b>
        <a v-if="info.phone" :href="'tel:'+info.phone">
          <svg height="34px" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0,0,256,256" ><g  fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none"  style="mix-blend-mode: normal;"><g  transform="scale(4,4)" ><path  d="M1,32c0,-17.1 13.9,-31 31,-31c17.1,0 31,13.9 31,31c0,17.1 -13.9,31 -31,31c-17.1,0 -31,-13.9 -31,-31z" fill="#3ec81c" ></path><path  d="M43.1,51.4c-0.7,0 -1.3,-0.1 -1.9,-0.4c-3.6,-1.6 -10.6,-5.1 -16.8,-11.3c-6.2,-6.2 -9.8,-13.3 -11.4,-16.9c-0.8,-1.8 -0.4,-3.9 1.1,-5.4l3.8,-3.8c0.5,-0.5 1.1,-0.9 1.8,-1c1,-0.2 2,0.2 2.7,0.9l4.9,4.9c1.3,1.3 1.3,3.4 0,4.8l-3.9,3.9c-0.4,0.4 -0.5,1 -0.3,1.5c0.7,1.5 2.3,4.6 5,7.3c2.7,2.7 5.8,4.3 7.3,5c0.5,0.2 1.1,0.1 1.5,-0.3l4,-4c0.5,-0.5 1,-0.8 1.7,-0.9c1,-0.2 2,0.1 2.8,0.9l5.1,5.1c1.2,1.2 1.2,3.2 0,4.4l-3.9,3.9c-0.9,0.9 -2.2,1.4 -3.5,1.4z" fill="#54e6eb"></path></g></g></svg>
        </a>
    </div>
    <div class="chat-header" v-if="productId > 0">
      <img v-if="info.media['0']?.url && info.media['0']?.type =='image'" :src="info.media['0'].url" alt="product image" height="100%">
      <svg v-else fill="currentColor" viewBox="0 0 97.6 77.3" height="100%"><path d="M16.3 24h.3c2.8-.2 4.9-2.6 4.8-5.4-.2-2.8-2.6-4.9-5.4-4.8s-4.9 2.6-4.8 5.4c.1 2.7 2.4 4.8 5.1 4.8zm-2.4-7.2c.5-.6 1.3-1 2.1-1h.2c1.7 0 3.1 1.4 3.1 3.1 0 1.7-1.4 3.1-3.1 3.1-1.7 0-3.1-1.4-3.1-3.1 0-.8.3-1.5.8-2.1z" fill="currentColor"></path><path d="M84.7 18.4 58 16.9l-.2-3c-.3-5.7-5.2-10.1-11-9.8L12.9 6c-5.7.3-10.1 5.3-9.8 11L5 51v.8c.7 5.2 5.1 9.1 10.3 9.1h.6l21.7-1.2v.6c-.3 5.7 4 10.7 9.8 11l34 2h.6c5.5 0 10.1-4.3 10.4-9.8l2-34c.4-5.8-4-10.7-9.7-11.1zM7.2 10.8C8.7 9.1 10.8 8.1 13 8l34-1.9c4.6-.3 8.6 3.3 8.9 7.9l.2 2.8-5.3-.3c-5.7-.3-10.7 4-11 9.8l-.6 9.5-9.5 10.7c-.2.3-.6.4-1 .5-.4 0-.7-.1-1-.4l-7.8-7c-1.4-1.3-3.5-1.1-4.8.3L7 49 5.2 17c-.2-2.3.6-4.5 2-6.2zm8.7 48c-4.3.2-8.1-2.8-8.8-7.1l9.4-10.5c.2-.3.6-.4 1-.5.4 0 .7.1 1 .4l7.8 7c.7.6 1.6.9 2.5.9.9 0 1.7-.5 2.3-1.1l7.8-8.8-1.1 18.6-21.9 1.1zm76.5-29.5-2 34c-.3 4.6-4.3 8.2-8.9 7.9l-34-2c-4.6-.3-8.2-4.3-7.9-8.9l2-34c.3-4.4 3.9-7.9 8.4-7.9h.5l34 2c4.7.3 8.2 4.3 7.9 8.9z" fill="currentColor"></path><path d="M78.2 41.6 61.3 30.5c-2.1-1.4-4.9-.8-6.2 1.3-.4.7-.7 1.4-.7 2.2l-1.2 20.1c-.1 2.5 1.7 4.6 4.2 4.8h.3c.7 0 1.4-.2 2-.5l18-9c2.2-1.1 3.1-3.8 2-6-.4-.7-.9-1.3-1.5-1.8zm-1.4 6-18 9c-.4.2-.8.3-1.3.3-.4 0-.9-.2-1.2-.4-.7-.5-1.2-1.3-1.1-2.2l1.2-20.1c.1-.9.6-1.7 1.4-2.1.8-.4 1.7-.3 2.5.1L77 43.3c1.2.8 1.5 2.3.7 3.4-.2.4-.5.7-.9.9z" fill="currentColor"></path></svg>
      <b v-if="info.title">{{ info.title }}</b>
    </div>
    <div class="chat-body">
      <div class="loading" v-if="!chatStore.isLoadedList">
        در حال بارگذاری...
      </div>
      <div v-if="chatStore.cardsList.length>0" style="display: flex;flex-direction: column-reverse;">
        <div
        v-for="list in chatStore.cardsList"
        :key="list.id"
        :class="['message', list.self ? 'me' : 'other',list.sending? 'sending' : '',list.deleted_at?'deleted':'',list.text?'':'deleted']"
        > 
          <div v-if="list && list.id && !list.deleted_at">
            <p v-if="list.text" style="word-break: break-all;">{{ list.text }}</p>
            <small v-if="list.updated_at || list.create_at">{{ list.updated_at || list.create_at }}</small>
            <br v-if="list.self">
            <a  v-if="list.self" @click="editChat(list)">
                edit
            </a>
            <a  v-if="list.self" @click="deleteChat(list.id)">
                delete
            </a>
          </div>
        </div>
        <div ref="el" v-if="chatStore.hasMoreList"></div>
      </div>
      <!-- <div v-else-if="chatStore.isLoadedList">
          <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0,0,256,256"><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal;"><g transform="scale(3.2,3.2)"><path d="M2.5,12.5h75v55h-75z" fill="#ffeea3" stroke="none"></path><path d="M77,13v54h-74v-54h74M78,12h-76v56h76v-56z" fill="#c0ad7c" stroke="none"></path><path d="M2.5,23.816l32.232,17.356c3.289,1.771 7.247,1.771 10.536,0l32.232,-17.356" fill="#ffeea3" stroke="#c0ad7c"></path></g></g></svg>
      </div> -->
    </div>
    <div class="chat-footer">
      <input
        v-if="showOne"
        v-model="chatMessage"
        placeholder="پیام خود را بنویسید..."
        @keyup.enter="sendMessage"
      />
      <button @click="sendMessage">ارسال</button>
    </div>
  </div>
</template>

<script setup>
  import { ref, defineProps, useTemplateRef, computed } from 'vue'
  import { useChatStore } from '@/stores/chat';
  import { useInfiniteScroll } from '@vueuse/core'
  import { polling } from '@/composables/polling'
  import { isDefrentChatListData } from '@/composables/polling/chat/isDefrentChatListData'
  import { useAlertStore } from '@/stores/alert'
  const alertStore = useAlertStore()
  const chatStore = useChatStore()
  const el = useTemplateRef('el')
  polling( 
      async () => await chatStore.fetchChatList(chatStore.cardsList.length > 0 ? chatStore.cardsList.length : 10 , 0 , false),
      {
          oldData:chatStore.cardsList??[],
          intervalMs: 6000,
          isDifferent: (newData) => isDefrentChatListData(chatStore.cardsList,newData),
          onChange: (allNewProduct) => {
              if(isDefrentChatListData(chatStore.cardsList??[],allNewProduct??[])){                
                if(chatStore.cardsList.length<allNewProduct.length){
                  alertStore.type=true
                  alertStore.msg='تغییرات جدید!'
                }
                chatStore.cardsList = allNewProduct??[]
              }
          }
      }
  )
  useInfiniteScroll(
      el, 
      async () => {
          await chatStore.fetchChatList(10,chatStore.cardsList.length,true) 
      } , { 
          distance: 50,
          canLoadMore: () => { 
              return chatStore.hasMoreList
          } 
      }
  )
  const props = defineProps({
    one: Boolean
  })
  const chatMessage = ref('')
  const editData = ref(null)
  const showOne = computed(()=>{ return props.one })
  const editChat = (list) => {
    editData.value = list
    chatMessage.value = list.text
  }
  const deleteChat = async (id) =>{
    const res = await chatStore.deleteChat(id)
    if(!res) return alertStore.msg = 'اتصال مشکل داره vpn خاموش کنید'
  }
  const sendMessage = async () => {
    if (!chatMessage.value) {
      alertStore.msg='پیام نمی تواند خالی باشد'
      return
    }
    const res = await chatStore.sendMessage(chatMessage.value,editData.value)
    if(res) {
      chatMessage.value = ''
      editData.value = null
      chatStore.cardsList = chatStore.fetchChatList(chatStore.cardsList.length > 0 ? chatStore.cardsList.length : 10 , 0 , false)
    }
  }
  const userId = computed(()=>{ return chatStore.userSelectedId })
  const productId = computed(()=>{ return chatStore.productSelectedId })
  const info = computed(()=>{return chatStore.chatInfo})
</script>

<style scoped>
  .chat-container {
    display: flex;
    flex-direction: column;
    height: 100%;
  } 
  .chat-header {
    padding: 10px;
    text-align: center;
    height: 40px;
    gap: 10px;
    box-shadow: -7px 0px 10px #c1bcbc;
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    flex-direction: row-reverse;
    justify-content: space-evenly;
  }
  .chat-body {
    flex: 1;
    padding: 10px;
    overflow-y: auto;
    overflow-x: hidden;
    max-height: 405px;
  }
  .message {
    padding: 8px 12px;
    margin-bottom: 10px;
    border-radius: 8px;
    max-width: 60%;
  }
  .me {
    background: #0458b3;
    color: white;
    margin-left: auto;
  }
  .other {
    background: #925454;
    color: white;
  }
  .chat-footer {
    direction: rtl;
    display: flex;
    border-top: 1px solid #eee;
  }
  .chat-footer input {
    flex: 1;
    padding: 8px;
    border: none;
    outline: none;
  }
  .chat-footer button {
    border: none;
    color: white;
    background: green;
    padding: 15px 25px;
  }
  .deleted {
    display: none !important;
  }
</style>
